import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"data-app":"true"}},[_c('JumbotronView',{attrs:{"message":_vm.message}}),_vm._v(" "),_c(VApp,{staticClass:"app-style mx-auto"},[_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12","md":"8","offset-md":"2"}},[_c('VerificationForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }